<script>
    import { CardLayout } from "../../../Components/Common/index.svelte";

    import {
        getAmountInCurrency,
        getText,
        getNumber,
    } from "../../../Utils/utilFunctions.svelte";

    import { openTabForSSO } from "../../ExternalGroups/helpers/ExternalGroupHelper.svelte";

    import { BillingStatus } from "../../../Utils/utilEnums.svelte";

    export let groupDetails = {};

    let isRedirectingSSO = false;

    const redirectToSSODomain = async (type = "", identifier = "") => {
        if (isRedirectingSSO) return;

        const { id, domain } = groupDetails;

        isRedirectingSSO = true;

        const goToPage = _getGoToPageByType(type, identifier);

        await openTabForSSO(id, domain, goToPage);

        isRedirectingSSO = false;
    };

    // HELPER FUNCTIONS
    const _getDomainUrl = (domain) => `https://${domain}/`;

    const _getGoToPageByType = (type, identifier) => {
        if (!type) return "";

        if (type == "era" || type == "eft")
            return `Reconciliations/tab=${type.toUpperCase()}s&page=0&size=25&reconciled=0`;

        if (type == "followup") return `${identifier}`;

        if (type == "encounter") {
            const targetStatus = BillingStatus.find(
                (bs) =>
                    bs.type.toLowerCase().replace(/\s+/g, "") ==
                    identifier.toLowerCase().replace(/\s+/g, ""),
            ).id;

            return `PatientEncounter/page=0&size=25&status=0&billingStatus=${targetStatus}`;
        }
    };
</script>

<CardLayout title="Group Details">
    <div class="flex flex-col">
        <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
            <div class="flex flex-col flex-1 gap-y-4 h-full">
                <div class="flex gap-x-2">
                    <p class="title">Group Name:</p>
                    <p class="content">{getText(groupDetails.name)}</p>
                </div>

                <div class="flex gap-x-2">
                    <p class="title">Domain:</p>
                    <p
                        class="content underline cursor-pointer hover:font-bold"
                        on:click|preventDefault={() => redirectToSSODomain()}
                    >
                        {_getDomainUrl(groupDetails.domain)}
                    </p>
                </div>

                <div class="flex gap-x-2">
                    <p class="title">Invoices Email:</p>
                    {#if groupDetails.invoicesEmail}
                        <a
                            href="mailto:{groupDetails.email}"
                            target="_blank"
                            class="content break-all hover:text-[#8A3ED7] hover:underline hover:font-bold"
                        >
                            {getText(groupDetails.invoicesEmail)}
                        </a>
                    {/if}
                </div>
            </div>

            <div class="divider lg:divider-horizontal" />

            <div class="flex flex-col flex-1 gap-y-4 h-full">
                <div class="flex gap-x-2">
                    <p class="title">Monthly Fixed Fee:</p>
                    <p class="content">
                        {getAmountInCurrency(groupDetails.monthlyFixedFee)}
                    </p>
                </div>

                <div class="flex gap-x-2">
                    <p class="title">Fixed Per Dr. Fee:</p>
                    <p class="content">
                        {getAmountInCurrency(groupDetails.fixedPerDrFee)}
                    </p>
                </div>

                <div class="flex gap-x-2">
                    <p class="title">Health Fund Billing Fee:</p>
                    <p class="content">
                        {getNumber(groupDetails.percentageHealthFundBillingFee)}%
                    </p>
                </div>

                <div class="flex gap-x-2">
                    <p class="title">Patient Billing Fee:</p>
                    <p class="content">
                        {getNumber(groupDetails.percentagePatientBillingFee)}%
                    </p>
                </div>
            </div>
        </div>
    </div>
</CardLayout>

<style>
    .title {
        width: 200px;
    }

    .content {
        width: calc(100% - 200px);
    }
</style>
